import React from 'react'
import InfoBanner from '../InfoBanner'

/**
 * Componente para mostrar la new Brand Equity (Contenido estático)
 *
 * @component
 *
 */

export const Recesion = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth)
  const breakpoint = 620

  React.useEffect(() => {
    const saveWidth = () => {
      setWidth(window.innerWidth)
    }

    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener('resize', saveWidth)

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    return () => window.removeEventListener('resize', saveWidth)
  }, [])

  const url = window.location.href

  return (
    <section id="news-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">News</span>
        </h2>
      </div>
      <InfoBanner
        section={'Recesión'}
        tittle={'Recesión: ¿reducir o reforzar el gasto en publicidad y marketing?'}
        readingTime={'Tiempo de lectura 6 minutos'}
        keywords={['Marketing', 'Estrategia']}
        urlDesktop={'/img/news/Recesion/recesion-img1-web.webp'}
        urlMobile={'/img/news/Recesion/recesion-img1-mob.webp'}
      />
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                En tiempos de recesión o crisis es común que las empresas recorten sus gastos en publicidad y marketing,
                pero ¿sabías que esto podría ser contraproducente? La realidad es que esta decisión puede tener
                consecuencias a largo plazo, impactando la marca y las oportunidades de negocio.
                Para contrarrestar este efecto se han identificado tres estrategias fundamentales respaldadas por investigaciones y
                casos prácticos, que permiten a las empresas sortear esta crisis con éxito
                <br></br>
                <br></br>
                1. Mantener el posicionamiento en la mente del consumidor.
                <br></br>
                <br></br>
                2. Evitar la dependencia en promociones de precio, ya que puede llegar a una erosión del valor de marca.
                <br></br>
                <br></br>
                3. Implementar prácticas creativas efectivas.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? '' : 'container-fluid padding-fluid'}
      >
        <div className={width < breakpoint ? '' : 'row'}>
          <div className={width < breakpoint ? '' : 'col-md-12'}>
            <div className={width < breakpoint ? '' : 'col-md-8 col-md-offset-2'}>
              <div className="imgWithText">
                <img
                  style={{ width: '100%' }}
                  className="img-responsive"
                  alt="Recesion"
                  src="/img/news/Recesion/Recesion_img2.webp"
                ></img>
                <h2 className="img3Text">
                  El consumidor piensa dos veces antes de elegir un producto en tiempos de recesión, por eso el posicionamiento se vuelve sumamente importante.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2">
              <p>
                <b>Mantener el posicionamiento en la mente del consumidor.</b>
                <br></br>
                <br></br>
                Durante las recesiones, la tentación de recortar gastos, incluida la publicidad,
                se vuelve palpable para muchas empresas. Sin embargo, este enfoque de "apagarse" o
                reducir la presencia en medios puede tener consecuencias adversas para la marca,
                como la erosión de su posición en el mercado debido a la falta de visibilidad.
                <br></br>
                <br></br>
                Un estudio de Ebiquity sobre el impacto de los gastos publicitarios durante la
                recesión del 2020 revela que las marcas que reducen su inversión publicitaria
                experimentan una disminución del 0,7% en su cuota de mercado en el primer trimestre,
                con dos años de recuperación. Por el contrario, aquellas que mantienen o aumentan su
                inversión alcanzan una cuota de mercado del 1,6% en el mismo periodo (Polman, 2020).
                <br></br>
                <br></br>
                Aquellas marcas que optan por invertir durante estos periodos suelen superar a las
                que recortan su presupuesto publicitario. Por eso, es crucial reconocer las oportunidades
                que ofrece una comunicación diversa para mantener y fortalecer la percepción del consumidor
                sobre la marca a largo plazo.
                <br></br>
                <br></br>
                Un ejemplo ilustrativo es el caso de una reconocida marca de productos para el hogar en Ecuador
                que, en 2023 cuando el país enfrentaba problemas energéticos que afectaban los gastos y operaciones
                de las empresas, en lugar de "apagarse", la marca trasladó su enfoque a los canales digitales y
                capitalizó el evento del Black Friday con una campaña denominada "Black Week". Esta estrategia
                resultó en un aumento del 30% en las búsquedas de la marca en Google en comparación con el año anterior,
                totalizando 102,300 búsquedas.
                <br></br>
                <br></br>
                Mientras muchas marcas optaron por una estrategia de recorte, esta marca vio una oportunidad y
                aumentó su inversión publicitaria en un 15% más en noviembre de 2023 en comparación con el mismo
                periodo del 2022. Este movimiento se tradujo en un incremento del 48% en las ventas, con un retorno de
                inversión publicitaria (ROAS) de $7,73, representando el 41% de las ventas del mes. La clave reside en la
                adaptabilidad, el mensaje y la situación particular durante momentos de recesión. Aumentar la inversión en
                publicidad puede convertirse en una estrategia de alto impacto.
                <br></br>
                <br></br>
                Por tanto, es esencial considerar la publicidad como una inversión estratégica en lugar de un simple costo,
                ya que contribuye significativamente a mantener la presencia y la relevancia de la marca en el mercado.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? '' : 'container-fluid padding-fluid'}
      >
        <div className={width < breakpoint ? '' : 'row'}>
          <div className={width < breakpoint ? '' : 'col-md-12'}>
            <div className={width < breakpoint ? '' : 'col-md-8 col-md-offset-2 text-center'}>
              <div className="imgWithText">
                <img
                  style={{ width: '100%' }}
                  className="img-responsive"
                  alt="Recesion"
                  src="/img/news/Recesion/Recesion_img3.webp"
                ></img>
                <h2 className="img3Text">
                  Las promociones son tentadoras al momento de que hay necesidad de ventas pero al mediano plazo pueden ser contraproducentes.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>Evitar la dependencia en promociones de precio, ya que puede llegar a una erosión del valor de marca.</b>
                <br></br>
                <br></br>
                Es crucial evitar depender en exceso de promociones de precio, ya que esto puede erosionar el valor de la marca. 
                Investigaciones como la IPA (Field, 2020) muestran que las estrategias de promoción a corto plazo pueden llevar a 
                una dependencia perjudicial y pérdida de ganancias a largo plazo. La eficacia de estas promociones disminuye con el tiempo, 
                ya que los consumidores comienzan a esperar descuentos constantes (ARF, 2018). Además, pueden afectar la lealtad del cliente, 
                el posicionamiento y la percepción de calidad de la marca.
                <br></br>
                <br></br>
                En lugar de centrarse únicamente en promociones de precio, es más efectivo utilizar gatilladores internos del consumidor y 
                estrategias de construcción de valor de marca. Mostrar a los consumidores el valor diferencial que están obteniendo y cómo están 
                maximizando su presupuesto puede ayudar a destacar frente a la competencia y conectar con los clientes durante periodos de recesión.
                <br></br>
                <br></br>
                <b>Implementar prácticas creativas efectivas</b>
                <br></br>
                <br></br>
                Es crucial adaptarse al consumidor durante la recesión, reflejando la realidad económica y conectando emocionalmente para lograr una 
                publicidad efectiva y resultados a largo plazo. 
                <br></br>
                <br></br>
                La investigación de la IPA muestra que, durante la recesión, las emociones juegan un papel clave. Los anuncios emocionales humanizan 
                la marca y generan una mayor resonancia entre los espectadores, especialmente aquellos centrados en el valor de la marca. 
                En contraste, las promociones de precio tienden a tener menos impacto (Russo, 2012).
                <br></br>
                <br></br>
                Las publicidades emocionales atraen un 47% más a los espectadores que las tradicionales, y un 33% más durante y después de la recesión. 
                Un ejemplo claro es el caso de <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.bing.com/videos/riverview/relatedvideo?&q=walmart+save+money+live+better&&mid=C6FA74BFA83E0BB1FB00C6FA74BFA83E0BB1FB00&&FORM=VRDGAR"
                >
                  Walmart
                </a>, que dirigió su mensaje a las madres durante la recesión, comunicando ahorro y un mejor estilo de vida. 
                <br></br>
                <br></br>
                Es esencial mantener una presencia publicitaria constante, evitar la dependencia excesiva de promociones de precio y adoptar prácticas 
                creativas alineadas con las necesidades y percepciones del consumidor. En RAM, comprendemos la importancia de no "apagarse", evitar 
                la promoción excesiva y optimizar los presupuestos con estrategias creativas para mitigar los riesgos económicos en mercados desafiantes. 
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? 'block' : 'none' }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Recesión`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: '7px' }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
